import axiosInstance from "../lib/axiosInstance";

class tagmodel {
    constructor() {
        this.base_url = '/tags'
    }
    async list(query = []) {

        return (await axiosInstance.get(`${this.base_url}?${new URLSearchParams(query)}`)).data;
    }
   

}

export default new tagmodel();


